import React from "react";
import { GoogleMap, OverlayView } from "@react-google-maps/api";
import Marker from "./marker/marker";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const MapComponent = ({
  onLoad,
  mapId,
  center,
  zoom,
  offices,
  selected,
  toggleSelected,
}) => {
  return (
    <div className="business-locator__map">
      <GoogleMap
        onLoad={onLoad}
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        options={{
          streetViewControl: false,
          fullscreenControl: false,
          mapTypeControl: false,
          mapId: mapId,
        }}
      >
        {offices.map((office) => {
          return (
            <OverlayView
              key={office.id}
              position={{
                lat: office.latitude,
                lng: office.longitude,
              }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <Marker
                key={office.id}
                office={office}
                selected={selected}
                toggleSelected={toggleSelected}
              />
            </OverlayView>
          );
        })}
      </GoogleMap>
    </div>
  );
};

export default MapComponent;
